import * as models from './models';

export function FullName(r: models.User): string {
    let s = '';

    const firstName = (r.firstName || '').trim();
    const lastName = (r.lastName || '').trim();

    if (firstName) {
        s += firstName;

        if (lastName) {
            s += ' ';
        }
    }

    if (lastName) {
        s += lastName;
    }

    return s;
}

export function FullNameWithCompany(r: models.User): string {
    let s = '';

    const company = (r.company || '').trim();
    const fullName = FullName(r);

    if (company) {
        s += company;

        if (fullName) {
            s += ' - ';
        }
    }

    if (fullName) {
        s += fullName;
    }

    return s;
}

export function GetFirstAndLast(fullName: string) {
    const names = fullName.split(' ');
    return {
        firstName: names.shift() || '',
        lastName: names.join(' '),
    };
}